import { createSlice } from "@reduxjs/toolkit";
import { ProductState } from "../interfaces/Product";

const initialState: ProductState = {
  products: [],
  categories: [],
  singleProduct: {},
  loading: false,
  search: "",
  allProducts: [],
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setProduct(state, action) {
      state.products = action?.payload;
    },
    setSingleProduct(state, action) {
      state.singleProduct = action?.payload;
    },
    setCategories(state, action) {
      state.categories = action?.payload;
    },
    setGlobalSearch(state, action) {
      state.search = action?.payload;
    },
    setAllProducts(state, action) {
      state.allProducts = action?.payload;
    },
  },
});

export const {
  setLoading,
  setProduct,
  setSingleProduct,
  setCategories,
  setGlobalSearch,
  setAllProducts,
} = productSlice.actions;

export default productSlice.reducer;
